// Budget-related constants
export const BUDGET_TYPES = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
    CUSTOM: 'custom',
  };
  
  export const BUDGET_CATEGORIES = {
    HOUSING: 'housing',
    TRANSPORTATION: 'transportation',
    FOOD: 'food',
    UTILITIES: 'utilities',
    INSURANCE: 'insurance',
    HEALTHCARE: 'healthcare',
    SAVINGS: 'savings',
    PERSONAL: 'personal',
    ENTERTAINMENT: 'entertainment',
    MISCELLANEOUS: 'miscellaneous',
  };
  
  export const BUDGET_STATUS = {
    ON_TRACK: 'on_track',
    WARNING: 'warning',
    OVER_BUDGET: 'over_budget',
  };
  
  export const BUDGET_THRESHOLDS = {
    WARNING: 0.8, // 80% of budget spent
    DANGER: 1.0,  // 100% of budget spent
  };